module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/244-south-sudan-e30304ba1fa2993566be4be430b5635b.svg";